import {getSnapshot} from 'mobx-state-tree'
import Presets from './Presets/Presets'
import {Component, React, observer, resolveCss} from '$src/handy'
import * as css from './Left.css'
import {ResearchStateTab} from '$src/bootstrap/Store'
import GenericButton from '$src/common/GenericButton'
import PremiseFilters from './PremiseFilters'
import RentFilters from "./RentFilters"

interface Props {
  css?: any
  activeTabState: typeof ResearchStateTab.Type
  frozen: boolean
  toggleRentTab: () => void
  rentTabState: boolean
  premiseData: any
  rentData: any
}

interface State {}

@observer
export default class Left extends Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context)
    this.state = {}
  }

  onSubmit = () => {}

  render() {
    const {props} = this
    const {frozen} = props
    const classes = resolveCss(css, props.css)
    
    return (
      <>
        <div {...classes('buttonContainer')} style={{paddingBottom: props.rentTabState ? '12px' : '0px'}}>
          <GenericButton
            variant={!props.rentTabState ? 'roundActive' : 'round'}
            withMargin
            onClick={props.rentTabState && props.toggleRentTab}
            style={{width: '150px', padding: '14px 10px'}}
          >
            Transactions
          </GenericButton>

          <GenericButton
            variant={props.rentTabState ? 'roundActive' : 'round'}
            withMargin
            onClick={!props.rentTabState && props.toggleRentTab}
            style={{width: '125px', padding: '14px 10px'}}
          >
            Rents
          </GenericButton>
        </div>
        <div {...classes('container', frozen && 'frozen')}>
          
          <div {...classes('presetsContainer')}>
            <Presets activeTabState={props.activeTabState} />
          </div>

          {props.rentTabState ? (
            <RentFilters onSubmit={this.onSubmit} valuesMst={props.activeTabState.query.formValues} frozen={frozen} rentData={props.rentData} />
          ) : (
            <PremiseFilters onSubmit={this.onSubmit} valuesMst={props.activeTabState.query.formValues} frozen={frozen} premiseData={props.premiseData} />
          )} 
        </div>
      </>
    )
  }
}


// WEBPACK FOOTER //
// ./src/comparableSales/Left.tsx